import {
	CreditLineAccountV2Response,
	CreditLineState,
	FinancingAccountV2Response,
	FinancingAccountV2ResponseLoanTypeEnum,
} from '../../../types/generated/pos';
import { getCreditMinPayment } from './getCreditMinPayment';

export type AccountEventOptions = {
	loanNumber: string;
	loanType: keyof typeof FinancingAccountV2ResponseLoanTypeEnum | 'CreditLine';
	nextPayment_date?: Required<FinancingAccountV2Response>['state']['dueDate'];
	nextPayment_amount?: Required<FinancingAccountV2Response>['state']['amount'];
};

export const getLoanEventOptions = (
	loan: FinancingAccountV2Response
): AccountEventOptions => {
	return {
		loanNumber: loan.id,
		loanType: loan.loanType,
		nextPayment_date: loan.state?.dueDate,
		nextPayment_amount: loan.state?.amount,
	};
};

export const getCreditEventOptions = (
	credit: CreditLineAccountV2Response,
	creditState?: CreditLineState | null
): AccountEventOptions => {
	return {
		loanNumber: credit.id,
		loanType: 'CreditLine',
		nextPayment_date: credit?.dueDate,
		nextPayment_amount: creditState
			? getCreditMinPayment(creditState)
			: undefined,
	};
};
